import { DictionaryItem } from "@app/shared/services/dictionary/dictionary-item.model";

export class AddressModel {
  postalCode: string;
  city: DictionaryItem;
  street: string;
  houseNumber: string;
  flatNumber: string;
}
